// extracted by mini-css-extract-plugin
export default {"paperContainer":"login_paperContainer__GMMpk","errorText":"login_errorText__Bf6Vw"};